import {createContext, useContext, type ReactNode} from 'react';

// Ticketing runs embedded inside Forecast (web-front ticketing-embed.tsx renders
// <App />, which provides this context as `true`). `embedded` decides which
// affordances exist — on the integrated path member management lives in Forecast,
// so role-editing UI is dropped in favor of a read-only view (ACC-447). Default
// false ⇒ components rendered outside a provider (e.g. focused unit tests) get
// the non-embedded behavior.
const EmbeddedContext = createContext<boolean>(false);

export function EmbeddedProvider({embedded, children}: {embedded: boolean; children: ReactNode}) {
	return <EmbeddedContext.Provider value={embedded}>{children}</EmbeddedContext.Provider>;
}

export function useEmbedded(): boolean {
	return useContext(EmbeddedContext);
}
